import React, {useMemo} from 'react'
import {NavLink} from "react-router-dom";
import {NAVIGATION_ITEM} from "../../../../constants/navigationItems";
import {Platz} from "./PlatzierungBereich";
import {vorhanden} from "./statistikWerte";

const WERTE = [
    {id: "ranglistePunkteGesamt", label: "Gesamt"},
    {id: "ranglistePunkte", label: "Rangliste"},
    {id: "ranglisteBestleistung", label: "Bestleistung", nurMitWert: true},
    {id: "ranglisteAnwesenheit", label: "Anwesenheit", nurMitWert: true},
];

/**
 * Ranglistenpunkte der Teilnehmer dieses Events im neuen Design.
 * Die alte Ansicht verwendet weiterhin PublicTournamentRanglisteTab.
 */
export default function RanglisteBereich({participants, eventOperatorId, rankingId}) {

    // gleiche Punkte ergeben den gleichen Platz, der nächste Platz wird dann übersprungen (1, 2, 2, 4)
    const zeilen = useMemo(() => {
        const sortiert = [...(participants || [])].sort((a, b) => b.ranglistePunkteGesamt - a.ranglistePunkteGesamt);
        let platz = 1;
        return sortiert.map((participant, index) => {
            if (index > 0 && participant.ranglistePunkteGesamt !== sortiert[index - 1].ranglistePunkteGesamt) {
                platz = index + 1;
            }
            return {participant, platz};
        });
    }, [participants]);

    // Bestleistung und Anwesenheit nur, wenn mindestens ein Teilnehmer dort Punkte hat
    const spalten = useMemo(() => WERTE.filter(w => !w.nurMitWert
        || (participants || []).some(participant => vorhanden(participant[w.id]) && Number(participant[w.id]) !== 0)), [participants]);

    const wert = (participant, id) => vorhanden(participant[id]) ? participant[id] : "–";

    return <div className="dhpt-statistik">
        {vorhanden(rankingId) &&
            <div className="dhpt-tab-kopfzeile">
                <NavLink className="dhpt-link-knopf" to={NAVIGATION_ITEM.PUBLIC_EVENTOPERATOR.route + "/" + eventOperatorId + "?tab=ranking&ranking=" + rankingId}>
                    <i className="pi pi-list" aria-hidden="true"/>
                    Zur Gesamtrangliste
                    <i className="pi pi-arrow-right dhpt-link-knopf-extern" aria-hidden="true"/>
                </NavLink>
            </div>
        }
        {zeilen.length === 0 ?
            <p className="dhpt-hinweis">Es sind noch keine Teilnehmer vorhanden.</p>
            :
            <div className="dhpt-st-rahmen">
                <table className="dhpt-tab dhpt-tab-rangliste" style={{"--dhpt-tab-spalten": spalten.length}}>
                    <caption className="dhpt-st-versteckt">Rangliste</caption>
                    <thead>
                    <tr>
                        <th scope="col" className="dhpt-tab-platz">Platz</th>
                        <th scope="col">Name</th>
                        {spalten.map(w => <th key={w.id} scope="col" className="dhpt-tab-zahl">{w.label}</th>)}
                    </tr>
                    </thead>
                    <tbody>
                    {zeilen.map(({participant, platz}) =>
                        <tr key={participant.id} className="dhpt-tab-zeile">
                            <td className="dhpt-tab-platz"><Platz platz={platz}/></td>
                            <td className="dhpt-tab-name">{participant.name}</td>
                            {/* data-label: Beschriftung der Werte in der Kartenansicht auf dem Handy */}
                            {spalten.map(w => <td key={w.id} data-label={w.label} className={"dhpt-tab-zahl dhpt-tab-" + w.id}>{wert(participant, w.id)}</td>)}
                        </tr>
                    )}
                    </tbody>
                </table>
            </div>
        }
    </div>
}
